import { useTranslation } from 'react-i18next';
import { Skeleton } from './skeleton';

export const LoadingState = ({
  label,
  rows = 3,
  className,
}: {
  label?: string;
  rows?: number;
  className?: string;
}) => {
  const { t } = useTranslation();
  return (
    <div role="status" className={['space-y-3', className].filter(Boolean).join(' ')}>
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} className="h-10 w-full" />
      ))}
      <span className="sr-only">{label ?? t('common.loading')}</span>
    </div>
  );
};
